import React, { Component } from "react";
import {
  TextField,
  Loadable,
  StyledButton,
  DescriptionField
} from "components/support";
import { WebhookActions } from "core/enum";

import Checkbox from "material-ui-next/Checkbox";
import Grid from "material-ui-next/Grid";
import Icon from "material-ui-next/Icon";
import IconButton from "material-ui-next/IconButton";
import Tooltip from "material-ui-next/Tooltip";

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions
} from "material-ui-next/Dialog";
import Typography from "material-ui-next/Typography";
import { FormControlLabel } from "material-ui-next/Form";
import style from "./style";

class WebhooksView extends Component {
  showLoading = () => {
    this.setState({ loading: true });
  };

  hideLoading = () => {
    this.setState({ loading: false });
  };

  handleFormFieldChange = (field, value) => {
    this.props.onChangeFormField({ field, value });
  };

  render() {
    const { viewModel, presenter, className } = this.props;
    const {
      loading,
      editingWebhook,
      webhook,
      errors,
      webhooks,
      companyUuid
    } = viewModel;

    return (
      <div
        className={`${className} grid-container full-height full-width mv-sm`}
      >
        <Loadable loading={loading}>
          <Typography type="headline">Webhooks</Typography>

          <hr />

          {webhooks.map(hook => (
            <Grid container alignItems="center" key={hook.uuid}>
              <Grid item xs>
                <DescriptionField value={hook.endpoint} />
              </Grid>
              <Grid item>
                <IconButton onClick={() => presenter.onEditWebhook(hook)}>
                  <Icon>mode_edit</Icon>
                </IconButton>
                <IconButton onClick={() => presenter.onDeleteWebhook(hook)}>
                  <Icon>delete</Icon>
                </IconButton>
              </Grid>
            </Grid>
          ))}

          <StyledButton
            label="Adicionar webhook"
            primary
            onTouchTap={() => presenter.onAddWebhook()}
            disabled={!companyUuid}
            style={{ pointerEvents: !companyUuid ? "none" : "auto" }}
          />
        </Loadable>

        <Dialog
          open={editingWebhook}
          onClose={() => presenter.onCancelEditing()}
        >
          <Loadable dark loading={loading}>
            <DialogTitle>
              {webhook.uuid ? "Editando" : "Criando"} webhook
            </DialogTitle>
            <DialogContent>
              <div className={className}>
                <TextField
                  fullWidth
                  label="URL"
                  value={webhook.endpoint}
                  onChange={e =>
                    presenter.onChangeWebhookEndpoint(e.target.value)
                  }
                  errorText={errors.endpoint}
                />

                <Grid container>
                  <Grid item xs={10} md={10}>
                    <span className="actions-label">
                      Headers Personalizados:
                    </span>
                  </Grid>
                  <Grid item xs={2} md={2} style={{ paddingTop: 10 }}>
                    <Tooltip
                      title="Adicionar Header Personalizado"
                      placement="left"
                    >
                      <StyledButton
                        primary
                        onClick={() => presenter.onAddCustomHeader()}
                      >
                        <Icon>add</Icon>
                      </StyledButton>
                    </Tooltip>
                  </Grid>
                </Grid>
                {webhook && webhook.custom_headers
                  ? webhook.custom_headers.map((header, key) => (
                      <Grid container key={key}>
                        <Grid item xs={10} md={10}>
                          <Grid container>
                            <Grid item xs={6} md={6}>
                              <TextField
                                fullWidth
                                label="Chave"
                                value={header.type}
                                onChange={e =>
                                  presenter.onChangeCustomHeader(
                                    e.target.value,
                                    key,
                                    "type"
                                  )
                                }
                              />
                            </Grid>
                            <Grid item xs={6} md={6}>
                              <TextField
                                fullWidth
                                label="Valor"
                                value={header.value}
                                onChange={e =>
                                  presenter.onChangeCustomHeader(
                                    e.target.value,
                                    key,
                                    "value"
                                  )
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={2} md={2}>
                          <Tooltip
                            title="Remover Header Personalizado"
                            placement="left"
                          >
                            <IconButton
                              style={{ marginTop: 26 }}
                              onClick={() => {
                                presenter.onRemoveCustomHeader(key);
                              }}
                            >
                              <Icon>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    ))
                  : null}
                <span className="actions-label">Ações:</span>

                <Grid container>
                  {Object.entries(WebhookActions).map(([key, actionName]) => (
                    <Grid item xs={12} md={6} key={key}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={webhook.actions.includes(key)}
                            className="checkbox-color"
                            onChange={e =>
                              presenter.onChangeWebhookAction(
                                key,
                                e.target.checked
                              )
                            }
                          />
                        }
                        label={actionName}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>
            </DialogContent>

            <DialogActions>
              <StyledButton flat onClick={() => presenter.onCancelEditing()}>
                Cancelar
              </StyledButton>
              <StyledButton primary onClick={() => presenter.onSave()}>
                Salvar
              </StyledButton>
            </DialogActions>
          </Loadable>
        </Dialog>
      </div>
    );
  }
}

export default style(WebhooksView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/webhooks/webhooks.view.jsx